import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { useExperiments } from '@johnlewispartnership/wtr-website-decisioner-client/express';
import { EOS_NEW_HEADER, MONETATE_DEFAULT_VARIANT } from 'constants/monetateExperiments';
import { BREAKPOINTS } from 'constants/grid';
import SiteHeader from '../SiteHeader';
import MobileSiteHeader from '../MobileSiteHeader';

export const SiteHeaderWrapper = () => {
  const { getExperimentById } = useExperiments();

  const { variant } = getExperimentById(EOS_NEW_HEADER.experiment);
  const isMobile = useMediaQuery({ maxWidth: BREAKPOINTS.md - 1 });

  return variant !== MONETATE_DEFAULT_VARIANT && isMobile ? <MobileSiteHeader /> : <SiteHeader />;
};
